export enum DynamicPage {
    CATEGORY = 'category',
    SEARCH = 'search',
    PRODUCTS = 'products',
    PRODUCT_DETAILS = 'product_details'
}

export enum CategoryLayoutType {
    LAYOUT_01 = 'category-page-layout-1',
    LAYOUT_02 = 'category-page-layout-2',
    LAYOUT_03 = 'category-page-layout-3',

}